import { px, seed } from "./utils";

export const DEMO_MPG={"Chevrolet|Tahoe|2021":{city:14,hwy:19,comb:16,fuelType:"Gasoline",annualFuelCost:3500,source:"demo"},"Ford|F-150|2020":{city:18,hwy:24,comb:20,fuelType:"Gasoline",annualFuelCost:2800,source:"demo"},"Ford|Mustang|1965":null};
export function simulateMpg(make,model,year){
  if(year&&year<1980)return null; // classics: no meaningful EPA-style rating
  const m=(model||"").toLowerCase();
  const isTruck=/tundra|f-150|f150|silverado|sierra|ram|tacoma|ranger|colorado|frontier/.test(m);
  const isSuv=/tahoe|suburban|expedition|explorer|highlander|4runner|pilot|traverse|yukon/.test(m);
  const isHybridEv=/prius|hybrid|leaf|bolt|model|ev6|ioniq/.test(m);
  const s=seed((make||"")+model+String(year||""));
  let base=isHybridEv?{city:48,hwy:45,comb:46}:isTruck?{city:17,hwy:22,comb:19}:isSuv?{city:19,hwy:25,comb:21}:{city:26,hwy:34,comb:29};
  const jitter=Math.round((s*6)-3);
  const city=Math.max(10,base.city+jitter),hwy=Math.max(12,base.hwy+jitter),comb=Math.round((city+hwy)/2);
  return{city,hwy,comb,fuelType:isHybridEv&&/leaf|bolt|ev6|ioniq/.test(m)?"Electricity":isHybridEv?"Gasoline/Electric Hybrid":"Gasoline",annualFuelCost:Math.round(1300000/comb/10)*10,source:"simulated"};
}
export function getDemoMpg(make,model,year){const exact=DEMO_MPG[`${make}|${model}|${year}`];if(exact!==undefined)return exact;return simulateMpg(make,model,year);}

export function normModelStr(s){return String(s||"").toLowerCase().replace(/[^a-z0-9]/g,"");}
export async function fetchFuelEconomyLive(year,make,model){
  // EPA's menu endpoints return JSON (not XML, despite ?format=xml) shaped like
  // {"menuItem":[{"text":"...","value":"..."}]} — and like a lot of XML-schema-derived
  // JSON APIs, a result set of exactly one item comes back as a bare object instead of
  // a one-item array, so we normalize that defensively below.
  const asItems=d=>{const m=d&&d.menuItem;return Array.isArray(m)?m:(m?[m]:[]);};

  // EPA stores model names in its own format (e.g. "F150 Pickup 2WD" vs our "F-150") —
  // fetch their actual model list for this year/make and fuzzy-match instead of assuming
  // our string matches theirs exactly, which silently returned nothing before.
  const modelListRes=await fetch(px(`https://www.fueleconomy.gov/ws/rest/vehicle/menu/model?year=${year}&make=${encodeURIComponent(make)}`));
  if(!modelListRes.ok)throw new Error("EPA model list request failed (HTTP "+modelListRes.status+")");
  const modelListText=await modelListRes.text();
  let modelListJson;try{modelListJson=JSON.parse(modelListText);}catch{throw new Error("EPA model list returned non-JSON. Raw: "+modelListText.slice(0,200));}
  const modelValues=asItems(modelListJson).map(i=>i.value);
  if(modelValues.length===0)throw new Error(`EPA has no models listed for ${year} ${make}`);
  const target=normModelStr(model);
  let matched=modelValues.find(v=>normModelStr(v)===target);
  if(!matched)matched=modelValues.find(v=>normModelStr(v).startsWith(target)||target.startsWith(normModelStr(v)));
  if(!matched)matched=modelValues.find(v=>normModelStr(v).includes(target)||target.includes(normModelStr(v)));
  if(!matched)throw new Error(`No EPA model match for "${model}" among: ${modelValues.slice(0,8).join(", ")}${modelValues.length>8?"...":""}`);

  const optRes=await fetch(px(`https://www.fueleconomy.gov/ws/rest/vehicle/menu/options?year=${year}&make=${encodeURIComponent(make)}&model=${encodeURIComponent(matched)}`));
  if(!optRes.ok)throw new Error("EPA options request failed (HTTP "+optRes.status+")");
  let optJson;try{optJson=JSON.parse(await optRes.text());}catch{throw new Error("EPA options returned non-JSON");}
  const firstId=asItems(optJson)[0]?.value;
  if(!firstId)throw new Error(`EPA matched model "${matched}" but returned no option/trim IDs`);

  const mpgRes=await fetch(px(`https://www.fueleconomy.gov/ws/rest/vehicle/${firstId}`));
  if(!mpgRes.ok)throw new Error("EPA vehicle detail request failed (HTTP "+mpgRes.status+")");
  const mpgText=await mpgRes.text();
  let mpgJson;try{mpgJson=JSON.parse(mpgText);}catch{throw new Error("EPA vehicle detail returned non-JSON. Raw: "+mpgText.slice(0,200));}
  const city=parseInt(mpgJson.city08)||null,hwy=parseInt(mpgJson.highway08)||null,comb=parseInt(mpgJson.comb08)||null,fuelType=mpgJson.fuelType1||null,annualFuelCost=parseInt(mpgJson.fuelCost08)||null;
  if(!city&&!hwy&&!comb)throw new Error(`EPA vehicle id ${firstId} (matched "${matched}") returned no MPG fields`);
  return{city,hwy,comb,fuelType,annualFuelCost,source:"live"};
}
export async function fetchFuelEconomy(year,make,model){
  try{return await fetchFuelEconomyLive(year,make,model);}
  catch{return getDemoMpg(make,model,year);}
}
